<style>
  .loading_gif{
    text-align: center;
    margin-top: 30%;
  }
  .loading-img{
    width:80px;
    height:60px;
    background-size: cover;
  }
  .prev{
    height:50px;
    text-align: center;
    line-height: 50px;
    float: left;
    width:10%;
  }
  .next{
    height:50px;
    text-align: center;
    line-height: 50px;
    float: right;
    width:10%;
  }
/*  #scollbar{
    position: fixed;
    left:0px;
    bottom:0px;
  }*/
  #Main {

    height: 50px;
    width:100%;
    position: fixed;
    bottom: 0px;
    /*border:1px solid red;*/

}

#scrollBar {

  width: 70%;

  height: 10px;

  background-color: #ccc;

  margin: 20px auto;
  -webkit-border-radius: 2em;

  -moz-border-radius: 2em;

  border-radius: 2em;

  cursor: pointer;

}
.scrolltext {
  width:100%;
  position: fixed;
  bottom:45px;
  /*border:1px solid red;*/
  text-align: center;
}
#scroll_Track {

  width: 0px;

  height: 10px;

  background-color: #1E88E5;

  -webkit-border-radius: 2em;

  -moz-border-radius: 2em;

  border-radius: 2em;

}

#scroll_Thumb {

  height: 15px;

  width: 15px;

  background-color: #efefef;

  -webkit-border-radius: 2em;

  -moz-border-radius: 2em;

  border-radius: 2em;

  border: 1px solid #ccc;

  -webkit-box-shadow: 0px 0px 5px #ccc;

  -moz-box-shadow: 0px 0px 5px #ccc;

  box-shadow: 0px 0px 5px #ccc;

  position: absolute;

  margin-top: -13px;

  cursor: pointer;

}

/*#scroll_Thumb:hover {

  background-color: #1E88E5;

  border: 1px solid #fff;

}*/

/*#progressBar {

  width: 80%;

  height: 10px;

  background-color: #ccc;

  margin: 0 auto;

  margin-top: 50px;

  -webkit-border-radius: 2em;

  -moz-border-radius: 2em;

  border-radius: 2em;

}*/

</style>
<template>
  <div class="container">
    <div class="loading_gif">
      <img src="../../static/images/loading.gif" class="loading-img">
      <p style="font-size:14px;">数据加载中,请稍等...</p>
      <!-- <span class="page_count" style="display:none;"></span> -->
    </div>
    <!-- <span class="prev" @click="prev">《</span>
    <span class="next" @click="next">》</span> -->
    <!-- <div>
      <button id='prev' @click="prev">上一页</button>
      <button id='next' @click="next">下一页</button>
      <span>Page: <span id='page_num'>{{page}}</span>/<span class="page_count"></span></span>
    </div> -->
    <!-- <span style="visibility:hidden;position:absolute;">Page: <span id='page_num'>{{page}}</span>/<span class="page_count"></span></span> -->
    <canvas id="theCanvas" style="background-size:cover;overflow:scroll;"></canvas>
     <div class="scrolltext" v-show="show">{{page}}/<span class="page_count"></span></div>
        <div id="Main" v-show="show">
        <div class="prev" @click="prev" style="background-image:url('../../static/images/left.png'); background-size:cover;"></div>
        <div class="next" @click="next" style="background-image:url('../../static/images/right.png');background-size:cover;background-position:-10px 0px;"></div>
          <div id="scrollBar">
            <div id="scroll_Track"></div>
            <div id="scroll_Thumb"></div>
          </div>
          <!-- <p id="scrollBarTxt" style="text-align:center;"></p> -->
         <!--  <span class="scrolltext"> 123</span> -->
        </div>
  </div>
</template>
<script>
import {apiUrl, alert} from '../helper'
import pdfjsLib from 'pdfjs-dist'
import $ from 'jquery'
import userMix from '../common/userMix'
import cookie from 'jquery.cookie'
export default {
  mixins: [userMix],
  data () {
    return {
      id: null,
      stype: null,
      pdate: null,
      m: '',
      page_count: 0,
      page: 0,
      startx: 0,
      starty: 0,
      endx: 0,
      endy: 0,
      fingers: 0,
      v: 0,
      distance: 0,
      pdfPath: null,
      scrollWidth: 0,
      currentX: 0,
      show: false,
      pid: 0,
      sessionid: ''
    }
  },
  route: {
    data ({ to }) {
      document.title = '公告'
      this.id = to.query.k || ''
      this.stype = to.query.t || null
      this.pdate = to.query.pdate || ''
      this.sessionid = to.query.sessionid || ''
      // 兼容小程序，安卓app
      console.log($.cookie())
      console.log(to)
      if (this.sessionid) { 
        $.cookie('sessionid', this.sessionid)
        this.getProfileNew()
      } else {
        this.getProfile('weixin')
      }
      if (to.query.pid) {
        var query = {'id': this.id, 'stype': this.stype, 'pdate': this.pdate, 'pid': to.query.pid}
      } else {
        var query = {'id': this.id, 'stype': this.stype, 'pdate': this.pdate}
      }     
      // let url = ''
      // url = this.sessionid ? '/V1.0.0/notice/noticemeta?sessionid=' + this.sessionid : '/V1.0.0/notice/noticemeta'
      $.ajax({
        url: apiUrl('/V1.0.0/notice/noticemeta'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify(query)
      }).done((response) => {
        if (response.status === 0) {
          let pdfPath = response.data.viewurl
          let num = pdfPath.indexOf('file')
          this.pdfPath = '/pdf/' + pdfPath.substr(num)
          console.log(this.pdfPath)
          pdfjsLib.PDFJS.cMapUrl =  './static/'
          pdfjsLib.PDFJS.cMapPacked  = true
          this.pdfjsLibDoc = pdfjsLib.getDocument(this.pdfPath)
          this.v = $(window).width() / 1000 * 100
          // this.renderP(this.page)
          this.scrollWidth = parseInt($(document).width()) * 0.7
          this.page = 1
          this.renderP(this.page)
        } else if (response.status === 403) {
          alert('请先登录！')
        } else {
          alert(response.description)
        }
      }).fail((response) => {
        alert('请求失败')
      })
      // this.pdfPath = '/pdf/file/view?path=' + this.id + '.pdf'
      // var cMapUrl = '../helper/cmaps'
      
      // this.page = 1
      // this.per = this.scrollWidth / parseInt($('.page_count').text())
      // alert(this.scrollWidth)
      // $('.prev').css('display','inline-block')
      // $('.next').css('display','inline-block')
      // loadingTask.promise.then(function (pdfDocument) {
      //   return this.renderP
      // }
    }
  },
  ready () {
    $("meta[name='viewport']").attr('content','width=device-width, initial-scale=1.0, user-scalable=no')
    document.getElementById('theCanvas').addEventListener('touchstart', this.touchstart)
    document.getElementById('theCanvas').addEventListener('touchend', this.touchend)
    document.getElementById('theCanvas').addEventListener('touchmove', this.touchmove)
    document.getElementById('theCanvas').addEventListener('touchcancel', this.touchend)
    document.getElementById('scroll_Thumb').addEventListener('touchmove', this.scroll)
    document.getElementById('scroll_Thumb').addEventListener('touchend', this.go)
    // document.getElementById('theCanvas').addEventListener('touch')
  },
  watch: {
    'page': function (newval, oldval) {
      let per = this.scrollWidth / parseInt($('.page_count').text())
      $("#scroll_Thumb").css("margin-left", this.page * per + "px")
      $("#scroll_Track").css("width", this.page * per + 2 + "px")
    }
  },
  methods: {
    getProfileNew (share) {
      $.ajax({
        url: apiUrl('/V1.0.0/user/profile'),
        method: 'post',
        dataType: 'json',
        async: false
      }).done((response) => {
        if (response.status === 0) {
          this.currentuser = response.data
          this.uid = response.data.uid
          this.shareUsername = response.data.username
          
        }
        if (response.status === 403 && share === 'weixin') {      // 未登录
          let appid = this.$config.weixin.appid
          let redirectUri = encodeURIComponent(window.location.href)
          window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect'
        }
      }).fail((response) => {
        console.log('请求失败')
      })
    },
    viewUrl: function (item) {
      if (item.viewtype === 1) {
        return '/#!/notice/' + this.id + '?stype=' + this.stype + '&pdate=' + this.pdate + '&idxname=' + ''
      }
      if (item.viewtype === 2) {
        return item.viewurl
      }
      if (item.viewtype === 3) {
        return item.downloadurl
      }
      if (item.viewtype === 4) {
        return '/#!/imgview?stype='+ this.stype + '&pdate=' + this.pdate + '&id=' + this.id
      }
    },
    scroll: function (e) {
      this.currentX = e.touches[0].clientX - parseInt($(document).width()) * 0.15
      // 每一页对应的进度条宽度
      let per = this.scrollWidth / parseInt($('.page_count').text())
      if (this.currentX >= per && this.currentX <= this.scrollWidth) {
        this.page = Math.floor(this.currentX / per)
        $("#scroll_Thumb").css("margin-left", this.page * per + "px")
        $("#scroll_Track").css("width", this.page * per + 2 + "px")
      } else if (this.currentX > this.scrollWidth){
        this.page = parseInt($('.page_count').text())
      } else if (this.currentX < per) {
        this.page = 1
      }
      // console.log(e.touches[0].clientX)
      // console.log(parseInt($(document).width()) * 0.15)
      // if (this.currentX >= 0 && this.currentX <= this.scrollWidth) {
      //   $("#scroll_Thumb").css("margin-left", this.currentX + "px")
      //   $("#scroll_Track").css("width", this.currentX + 2 + "px")
      //   this.page = Math.round(parseInt($('.page_count').text()) / this.scrollWidth * this.currentX)
      // } else if (this.currentX < 0){
      //   this.page = 1
      // } else if (this.currentX > this.scrollWidth) {
      //   this.page = parseInt($('.page_count').text())
      // }
    },
    go () {
      this.renderP(this.page)
    },
    renderP (n) {
      // this.pdfjsLibDoc.promise.then(function (pdfDocument) {
      //   // console.log(pdfDocument)
      //   $('.page_count').text(pdfDocument.numPages)
      //   return pdfDocument.getPage(n).then(function (pdfPage) {
      //     // console.log(pdfPage)
      //     var a
      //     if (pdfPage.view[2] > $(window).width()) {
      //       a = $(window).width() / pdfPage.view[2]
      //     } else {
      //       a = $(window).width() / pdfPage.view[2]
      //     }
      //     let viewport = pdfPage.getViewport(a)
      //     console.log(viewport)
      //     let canvas = document.getElementById('theCanvas')
      //     // 设置宽度
      //     console.log($(window).width())
      //     canvas.width = $(window).width()
      //     // viewport.width = $(window).width()
      //     // viewport.viewBox[2] = $(window).width()
      //     console.log(canvas.width)
      //     // 设置高度
      //     canvas.height = viewport.height
      //     // viewport.height = $(window).height()
      //     // viewport.viewBox[3] = $(window).height()
      //     console.log(canvas.height)
      //     let ctx = canvas.getContext('2d')
      //     let renderTask = pdfPage.render({
      //       canvasContext: ctx,
      //       viewport: viewport
      //     })
      //     return renderTask.promise
      //   })
      // })
      this.pdfjsLibDoc.promise.then(function (pdfDocument) {
        // console.log(pdfDocument)
        $('.page_count').text(pdfDocument.numPages)
        let v = $(window).width() / 1000 * 100
        $('#theCanvas').css('zoom', v + '%') 
        return pdfDocument.getPage(n).then(function (pdfPage) {
          // console.log(pdfPage)
          var a
          if (pdfPage.view[2] > 1000) {
            a = 1000 / pdfPage.view[2]
          } else {
            a = 1000 / pdfPage.view[2]
          }
          let viewport = pdfPage.getViewport(a)
          console.log(viewport)
          let canvas = document.getElementById('theCanvas')
          // 设置宽度
          
          canvas.width = 1000
          // viewport.width = $(window).width()
          // viewport.viewBox[2] = $(window).width()
          console.log(canvas.width)
          // 设置高度
          canvas.height = viewport.height
          // viewport.height = $(window).height()
          // viewport.viewBox[3] = $(window).height()
          console.log(canvas.height)
          let ctx = canvas.getContext('2d')
          let renderTask = pdfPage.render({
            canvasContext: ctx,
            viewport: viewport
          })
          $('.loading_gif').css('display', 'none')
          // $('.prev').css('display','inline-block')
          // $('.next').css('display','inline-block')
          return renderTask.promise
        }).then(function () {
          $('.prev').css('display','inline-block')
          $('.next').css('display','inline-block')
          // alert(n)
          if (n === 1) {
            let per = parseInt($(document).width()) * 0.7 / parseInt($('.page_count').text())
            $("#scroll_Thumb").css("margin-left", n * per + "px")
            $("#scroll_Track").css("width", n * per + 2 + "px")
          }
        })
      })
      // let v = $(window).width() / 1000 * 100
      // $('#theCanvas').css('zoom', v + '%')
      // $('.prev').css('display','inline-block')
      // $('.next').css('display','inline-block')
    },
    prev: function () {
      this.show = true
      if (this.page === 1) {
        return
      } else {
        this.page = this.page - 1
        $('.prev').css('display','none')
        $('.next').css('display','none')
        this.renderP(this.page)
      }
      // $('.prev').css('display','inline-block')
      // $('.next').css('display','inline-block')
    },
    next: function () {
      this.show = true
      let pagecount = parseInt($('.page_count').text())
      // console.log('pagecount:' + pagecount)
      // console.log(pagecount + '--' + this.page)
      if (this.page === pagecount) {
        return
      } else {
        this.page = this.page + 1
        // console.log(this.page + '!!')
        $('.prev').css('display','none')
        $('.next').css('display','none')
        this.renderP(this.page)
      }
      // $('.prev').css('display','inline-block')
      // $('.next').css('display','inline-block')
    },
    touchstart: function (e) {
      // $('.prev').css('display','inline-block')
      // $('.next').css('display','inline-block')
      // e.preventDefault()
      if (e.touches.length === 2) {
        this.fingers = 2
        // alert(e.touches.length)
        // this.fingers = this.fingers + 2
        let x = Math.abs(e.touches[0].clientX - e.touches[1].clientX)
        let y = Math.abs(e.touches[0].clientY - e.touches[1].clientY)
        let distance = Math.pow((x * x + y * y), 0.5)
        // 算出两个手指之间的距离
        this.distance = distance
        this.x1 = (e.touches[0].clientX + e.touches[1].clientX) / 2
        this.y1 = (e.touches[0].clientY + e.touches[1].clientY) / 2
        // 算出中心点
        // let a = ['-o-transform-origin', '-moz-transform-origin', '-webkit-transform-origin', '-ms-transform-origin', 'transform-origin']
        // for(let i of a ) {
        //   document.getElementById('theCanvas').style[a[i]] = x1 + 'px' + ' ' + y1 + 'px' 
        // }
        // alert(document.getElementById('theCanvas').style)
        // console.log($('#theCanvas').width())
      } 
      if (e.touches.length === 1) {
        this.fingers = 1
        if ($('.page_count').text()) {
          this.show = !this.show
        }
        // this.fingers++
        this.startx = e.touches[0].clientX
        this.starty = e.touches[0].clientY
        console.log('sx:' + this.startx + '   ' + 'sy' + this.starty)
      }
    },
    touchmove: function (e) {
      // e.preventDefault()
      if (e.touches.length === 2) {
        let x = Math.abs(e.touches[0].clientX - e.touches[1].clientX)
        let y = Math.abs(e.touches[0].clientY - e.touches[1].clientY)
        let distance = Math.pow((x * x + y * y), 0.5)
        let rate = distance - this.distance
        this.v = this.v + rate / 4
        if (this.v < ($(window).width() / 1000 * 100)) {
          $('#theCanvas').css('zoom', $(window).width() / 1000 * 100 + '%')
        } else {
          $('#theCanvas').css('zoom', this.v + '%')
        }
        // $('#theCanvas').scrollTo(this.x1, this.y1)

        // let rate = (distance - this.distance) / 2 + 1
        // let s = ['transform', '-o-transform', '-webkit-transform', '-ms-transform', '-moz-transform']
        // for (let k of s) {
        //   document.getElementById('theCanvas').style[s[k]] = 'scale(' + rate + ')'
        // }
        // document.getElementById('theCanvas').style['-webkit-transform'] = 'scale(' + rate + ')'
        // $('#theCanvas').css('-webkit-transform','translate(' + -this.x1 + 'px' + ',' + -this.y1 + 'px' + ')')
        this.distance = distance
      }
      // if (e.touches.length === 1) {
      //   console.log($('#theCanvas').css('zoom'))
      //   if ($('#theCanvas').css('zoom') === 0.375) {
      //     if (e.touches[0].clientX - this.startx > 50) {
      //       this.prev()
      //     }
      //     if (e.touches[0].clientX - this.startx < -50) {
      //       this.next()
      //     }
      //   }
      // }
    },
    touchend: function (e) {
      // this.endx = e.changedTouches[0].clientX
      // this.endy = e.changedTouches[0].clientY
      // console.log('ex:' + this.endx + '   ' + 'ey' + this.endy)
      // let d = this.endx - this.startx
      // let t = this.endy - this.starty
      // this.fingers--
     
        console.log($('#theCanvas').css('zoom'))
        console.log($(window).width() / 1000)
        if (this.fingers === 1) {
          if ($('#theCanvas').css('zoom') === new Number($(window).width() / 1000).toString()){
            console.log(e.changedTouches)
            if (e.changedTouches[0].clientX - this.startx > 50) {
              this.prev()
            }
            if (e.changedTouches[0].clientX - this.startx < -50) {
              this.next()
            }
          }
        }
        
      
      // if (this.fingers === 1) {
      //   if (this.startx < 50 || this.startx > $(window).width() - 50 || this.starty < 100 || this.starty > $(window).height() - 100) {
      //     if (Math.abs(d) > Math.abs(t)) {
      //       if (d > 30) {
      //       this.prev()
      //       }
      //       if (d < -30) {
      //         this.next()
      //       }
      //     } else {
      //       if (t > 30 ) {
      //         this.prev()
      //       }
      //       if (t < -30) {
      //         this.next()
      //       }
      //     }
      //   }
      // }
      // if (this.fingers === 2) {
      //   return flase
      // }
    }
  }
}
</script>



/** WEBPACK FOOTER **
 ** NoticeDetail.vue?614c023f
 **/